export const $symbols = {
    all: [
        'circle-arrow-left',
        'circle-arrow-right',
        'circle-binoculars',
        'circle-camera',
        'circle-crown',
        'circle-eye-1',
        'circle-eye-2',
        'circle-eye-3',
        'circle-eye-4',
        'circle-eye-5',
        'circle-eye-6',
        'circle-eye-7',
        'circle-eye-anim',
        'circle-hand-cool',
        'circle-heart',
        'circle-mic',
        'circle-mobil',
        'circle-mouth-1',
        'circle-mouth-2',
        'circle-mouth-3',
        'circle-mouth-4',
        'circle-mouth-5',
        'circle-mouth-6',
        'circle-note-1',
        'circle-note-2',
        'circle-pat',
        'circle-play',
        'circle-saxophone',
        'circle-skull',
        'circle-star',
        'circle-theater',
        'circle-ticket-1',
        'circle-ticket-2',
        'circle-umbrella',
        'square-arrow-left',
        'square-arrow-right',
        'square-binoculars',
        'square-camera',
        'square-crown',
        'square-eye-1',
        'square-eye-2',
        'square-eye-3',
        'square-eye-4',
        'square-eye-5',
        'square-eye-6',
        'square-eye-7',
        'square-hand-cool',
        'square-heart',
        'square-mic',
        'square-mobil',
        'square-mouth-1',
        'square-mouth-2',
        'square-mouth-3',
        'square-mouth-4',
        'square-mouth-5',
        'square-mouth-6',
        'square-note-1',
        'square-note-2',
        'square-pat',
        'square-play',
        'square-saxophone',
        'square-skull',
        'square-star',
        'square-theater',
        'square-ticket-1',
        'square-ticket-2',
        'square-umbrella',
        'triangle-arrow-left',
        'triangle-arrow-right',
        'triangle-binoculars',
        'triangle-camera',
        'triangle-crown',
        'triangle-eye-1',
        'triangle-eye-2',
        'triangle-eye-3',
        'triangle-eye-4',
        'triangle-eye-5',
        'triangle-eye-6',
        'triangle-eye-7',
        'triangle-hand-cool',
        'triangle-heart',
        'triangle-mic',
        'triangle-mobil',
        'triangle-mouth-1',
        'triangle-mouth-2',
        'triangle-mouth-3',
        'triangle-mouth-4',
        'triangle-mouth-5',
        'triangle-mouth-6',
        'triangle-note-1',
        'triangle-note-2',
        'triangle-pat',
        'triangle-play',
        'triangle-saxophone',
        'triangle-skull',
        'triangle-star',
        'triangle-theater',
        'triangle-ticket-1',
        'triangle-ticket-2',
        'triangle-umbrella',
    ]
}
